<mat-label>{{ title }}</mat-label>
<mat-form-field class="filter-form-field" appearance="outline">
    <mat-select
        [formControl]="selectedItem"
        (selectionChange)="onSelectionChangeInternal()"
        [multiple]="true"
        (closed)="onSelectClosed()"
        (openedChange)="onSelectOpened($event)"
    >
        <mat-select-trigger>
            {{ selectedItem.value?.join(', ') }}
        </mat-select-trigger>

        <div class="panel-template" *ngIf="panelTemplate" (click)="$event.stopPropagation()">
            <ng-container
                *ngTemplateOutlet="panelTemplate"
            ></ng-container>
        </div>
        <mat-divider *ngIf="panelTemplate"></mat-divider>
        
        <mat-option>
            <ngx-mat-select-search
                [formControl]="searchFilterCtrl"
                placeholderLabel="Search..."
                noEntriesFoundLabel="No results found"
            >
            </ngx-mat-select-search>
        </mat-option>
        @for(item of $filteredItems(); track $index) {
        <mat-option [value]="item" [disabled]="isItemDisabled(item)">
            @if(itemTemplate) {
            <ng-container
                *ngTemplateOutlet="
                    itemTemplate;
                    context: { $implicit: item, index: $index }
                "
            ></ng-container>
            } @else {
            {{ item }}
            }
        </mat-option>
        }
        <mat-divider></mat-divider>

        <div class="actions">
            <button mat-button color="primary" (click)="applySelection($event)">
                <span style="font-weight: bold">Apply</span>
            </button>
            <button
                mat-button
                color="primary"
                (click)="cancelSelection($event)"
            >
                <span style="font-weight: bold">Cancel</span>
            </button>
        </div>
    </mat-select>
</mat-form-field>
